/**
 * @desc geojson helper
 */
import * as lodash from '../../utils/lodash';
export function wgs84toWebMercator(lon, lat) {
    var x = (lon * 20037508.342789) / 180;
    var y = Math.log(Math.tan(((lat + 90) * Math.PI) / 360)) / (Math.PI / 180);
    y = (y * 20037508.34789) / 180;
    return [x, y];
}
export function getGeometryBBox(geometry) {
    var minLong;
    var maxLong;
    var minLat;
    var maxLat;
    if (geometry.type === 'FeatureCollection') {
        var bboxList = geometry.features.map(function (feature) { return getGeometryBBox(feature.geometry); });
        var longList = lodash.flatten(bboxList.map(function (bbox) { return bbox[0]; }));
        var latList = lodash.flatten(bboxList.map(function (bbox) { return bbox[1]; }));
        minLong = lodash.min(longList);
        maxLong = lodash.max(longList);
        minLat = lodash.min(latList);
        maxLat = lodash.max(latList);
    }
    else if (geometry.type === 'GeometryCollection') {
        var bboxList = geometry.geometries.map(function (item) { return getGeometryBBox(item); });
        var longList = lodash.flatten(bboxList.map(function (bbox) { return bbox[0]; }));
        var latList = lodash.flatten(bboxList.map(function (bbox) { return bbox[1]; }));
        minLong = lodash.min(longList);
        maxLong = lodash.max(longList);
        minLat = lodash.min(latList);
        maxLat = lodash.max(latList);
    }
    else {
        var coordinates = void 0;
        if (geometry.type === 'Point') {
            coordinates = [geometry.coordinates];
        }
        else if (geometry.type === 'LineString') {
            coordinates = geometry.coordinates;
        }
        else if (geometry.type === 'Polygon') {
            coordinates = lodash.flatten(geometry.coordinates);
        }
        else if (geometry.type === 'MultiPoint') {
            coordinates = geometry.coordinates;
        }
        else if (geometry.type === 'MultiLineString') {
            coordinates = lodash.flatten(geometry.coordinates);
        }
        else if (geometry.type === 'MultiPolygon') {
            coordinates = lodash.flatten(lodash.flatten(geometry.coordinates));
        }
        minLong = lodash.min(coordinates.map(function (coord) { return coord[0]; }));
        maxLong = lodash.max(coordinates.map(function (coord) { return coord[0]; }));
        minLat = lodash.min(coordinates.map(function (coord) { return coord[1]; }));
        maxLat = lodash.max(coordinates.map(function (coord) { return coord[1]; }));
    }
    return [
        [minLong, maxLong],
        [minLat, maxLat],
    ];
}
